import styled from 'styled-components'
import theme from '../../client/theme'

export const FirstCol = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 100%;

  @media screen and (min-width: ${theme.breakpoints.large}) {
    text-align: left;
    width: auto;
    align-items: flex-start;
  }
`

export const WrapperLogo = styled.div`
  margin: 0px 0px 20px;
`
